import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config-service/app-config.service';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';
import { TrustAddressModel } from '../../models/trust-address';
import { TrustScheduleModel } from '../../models/trust-schedule-model';
import { UsefulWebsite } from '../../models/useful-website';
import { Observable } from 'rxjs';
import { DataQuality } from '../../models/data-quality';
import { HomeCardModel } from '../../models/home-card-model';

@Injectable()
export class TrustDataService {

  constructor(private appConfigService: AppConfigService, private http: AuthHttpClient) { }

  addSchedule(trustScheduleModel: TrustScheduleModel) {
    return this.http.post(this.appConfigService.addTrustSchedule, trustScheduleModel);
  }

  getTrustSchedules() {
    return this.http.get(this.appConfigService.TrustSchedules);
  }

  getTrustReportConfiguration() {
    return this.http.get(this.appConfigService.TrustReportConfigurationGet);
  }

  updateReportConfiguration(reportConfiguration: any) {
    return this.http.post(this.appConfigService.TrustReportConfigurationPost, reportConfiguration);
  }

  getAllTrustCards() {
    return this.http.get(this.appConfigService.getAllTrustCards);
  }

  getTrustCard(cardName: string) {
    return this.http.get(this.appConfigService.getTrustCard.replace('{cardName}', cardName));
  }

  updateTrustCard(card: any) {
    return this.http.post(this.appConfigService.updateTrustCardPost, card);
  }

  getUsefulWebsites() {
    return this.http.get(this.appConfigService.usefulWebsiteGet);
  }

  getTrustDataQualityContact() {
    return this.http.get(this.appConfigService.TrustDataQualityGet);
  }

  updateTrustDataQualityContact(dataQuality: DataQuality) {
    return this.http.post(this.appConfigService.TrustDataQualityUpdatePost, dataQuality);
  }

  updateUsefulWebsite(usefulWebsite: UsefulWebsite) {
    return this.http.post(this.appConfigService.usefulWebsiteUpdate, usefulWebsite);
  }

  addUsefulWebsite(usefulWebsite: UsefulWebsite) {
    return this.http.post(this.appConfigService.usefulWebsiteAdd, usefulWebsite);
  }

  deleteUsefulWebsite(usefulWebsite: UsefulWebsite) {
    return this.http.post(this.appConfigService.usefulWebsiteDelete, usefulWebsite);
  }

  getTrustAddresses() {
    return this.http.get(this.appConfigService.TrustAddresses);
  }

  updateTrustAddress(trustAddress: TrustAddressModel) {
    return this.http.post(this.appConfigService.UpdateTrustAddress, trustAddress);
  }

  addTrustAddress(trustAddress: TrustAddressModel) {
    return this.http.post(this.appConfigService.AddTrustAddress, trustAddress);
  }

  deleteTrustAddress(trustAddress: TrustAddressModel) {
    return this.http.post(this.appConfigService.DeleteTrustAddress, trustAddress);
  }

  deleteSchedule(trustScheduleModel: TrustScheduleModel) {
    return this.http.post(this.appConfigService.DeleteTrustSchedule, trustScheduleModel);
  }

  updateSchedule(trustScheduleModel: TrustScheduleModel) {
    return this.http.post(this.appConfigService.UpdateTrustSchedule, trustScheduleModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/trust-data-service/trust-data.service.ts